import { WSServiceError } from "../../../../utils/serviceHelper";
import { WSService } from "../../../../utils/WSService";
import { ListPayablesRequest, ListPayablesResponse, Payable } from "./types";

const service = new WSService("/v2/payments/payables");

export const listPayables = async (
  request: ListPayablesRequest
): Promise<ListPayablesResponse> => {
  try {
    const { data, headers } = await service.get("", { params: request });

    return {
      items: data as Payable[],
      nextPageToken: (headers["x-ws-page-token"] as string) || undefined,
      resultSetId: (headers["x-ws-result-set-id"] as string) || undefined
    };
  } catch (err) {
    // TEMP: wingspan-api 500s on empty filter results until the @wingspanhq/grpc
    // empty-resultset fix (grpc#66) is released and adopted. Treat 500 as empty
    // so the UI is testable; remove once the grpc bump lands.
    if ((err as WSServiceError)?.response?.status === 500) {
      return { items: [], nextPageToken: undefined, resultSetId: undefined };
    }
    throw err;
  }
};
